// One schema per tenant club. The club room template (pages/ClubRoomPage) renders entirely from this —
// to add a club you fill a schema, you do not write JSX. Palettes and copy come from each club's own site
// (captured in /app/memory/clubs/*.md). Everything here is a DEFAULT: whatever the club saves in their own
// dashboard (ticker, venues, notices, blurb) overrides it.

const v = (day, name, time = "", note = "", buyin = "", prize = "", blinds = "", rego = "", late = "") =>
  ({ day, name, time, note, buyin, prize, blinds, rego, late });

// Default tables roll forward with the calendar so a club's room never shows a stale date.
const inDays = (n) => {
  const d = new Date();
  d.setDate(d.getDate() + n);
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
};
const g = (name, day, time, prize, game = "HOLDEM", seats = 8) =>
  ({ name, game, seats, free: true, buyin: "", prize, date: inDays(day), time });

export const CLUBS = [
  {
    slug: "crp",
    name: "Check Raise Poker",
    short: "Check Raise",
    tile: "/assets/club_crp.png",
    tileFit: "contain",
    tileBg: "linear-gradient(135deg, #0A0A0A 0%, #12264F 55%, #2F6BD8 100%)",
    tileLogo: "/assets/clubs/crp/logo_white.png",
    theme: {
      ground: "#0A0A0A",
      surface: "#141414",
      line: "rgba(255,255,255,0.12)",
      ink: "#FFFFFF",
      inkSoft: "rgba(255,255,255,0.62)",
      accent: "#2F6BD8",        // their table-rail blue
      accentDeep: "#1B3FA0",    // their felt
      onAccent: "#FFFFFF",
      display: "'Anton', 'Unbounded', sans-serif",
      body: "'Epilogue', 'IBM Plex Sans', sans-serif",
      displayTracking: "0.01em",
      radius: "2px",            // hard edges — nothing about this brand is soft
      pill: "9999px",
    },
    logo: "/assets/clubs/crp/logo_white.png",
    logoDark: "/assets/clubs/crp/logo_black.png",
    felt: "table_felt_blue",
    lobby: "/assets/clubs/crp/bg_lobby_hd.jpg",
    tvs: [[[2898, 830], [3628, 695], [3628, 1084], [2898, 1127]]],   // the lit sign on the right wall
    hero: "/assets/clubs/crp/photo_room.jpg",
    eyebrow: "Players Room · club lounge",
    headline: "Every hand is a new opportunity",
    blurb:
      "Check Raise Poker runs the busiest pub circuit in South East Queensland — seventeen games a week across " +
      "Inala, Raceview, Springwood, Springlake, Loganholme, Waterford, Jindalee, Orion, Beenleigh, Goodna, " +
      "Salisbury and The Witch. This is their room inside Players Room: their satellites, their qualifiers and " +
      "their online games, built to their order.",
    ticker: ["JOIN OUR MEMBERS ONLY COMMUNITY NOW"],
    cta: { label: "Tonight's games", href: "#games" },
    games: [
      g("Monday Night Freeroll", 0, "7:30pm", "Ticket to the CRP Championships — $500 Main Event seat"),
      g("Inala Qualifier", 1, "7:30pm", "Ticket to the Salisbury Super Sunday — $250 seat"),
      g("Circuit Warm-Up", 2, "7:30pm", "Ticket to the Orion Thursday Major — $250 seat"),
    ],
    venues: [
      v("MON", "Inala Hotel", "6:30pm", "", "$30 + $10", "$1,500 GTD", "100/200 · 20 min", "6:00pm", "8:00pm"),
      v("MON", "Raceview Hotel", "7:00pm", "", "$20 + $10", "$800 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("MON", "Lions @ Springwood", "7:00pm", "", "$30 + $10", "$1,000 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("TUE", "Springlake Hotel", "7:00pm", "", "$20 + $10", "$750 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("TUE", "Fitzys Loganholme", "7:00pm", "", "$30 + $10", "$1,200 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("WED", "Fitzy's Waterford", "7:00pm", "", "$30 + $10", "$1,500 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("WED", "The Jindalee", "7:00pm", "", "$20 + $10", "$800 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("THU", "Inala Hotel", "12:00pm", "Day", "$20 + $10", "$600 GTD", "100/200 · 15 min", "11:30am", "1:30pm"),
      v("THU", "Orion Hotel", "7:00pm", "", "$30 + $10", "$1,000 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("THU", "Beenleigh RSL & Golf", "7:00pm", "", "$30 + $10", "$1,200 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("THU", "Hollywood Showgirls", "7:30pm", "Fortnightly", "$50 + $15", "$2,500 GTD", "100/200 · 25 min", "7:00pm", "9:00pm"),
      v("FRI", "The Witch Hotel", "12:00pm", "Day", "$20 + $10", "$600 GTD", "100/200 · 15 min", "11:30am", "1:30pm"),
      v("FRI", "Goodna RLFC", "7:00pm", "Night", "$30 + $10", "$1,000 GTD", "100/200 · 20 min", "6:30pm", "8:30pm"),
      v("SAT", "Salisbury Hotel", "6:30pm", "", "$50 + $15", "$3,000 GTD", "100/200 · 25 min", "6:00pm", "8:00pm"),
      v("SUN", "Springlake Hotel", "12:00pm", "Day", "$20 + $10", "$750 GTD", "100/200 · 15 min", "11:30am", "1:30pm"),
      v("SUN", "Inala Hotel", "6:30pm", "Night", "$30 + $10", "$1,500 GTD", "100/200 · 20 min", "6:00pm", "8:00pm"),
    ],
    notices: [
      { kind: "OFFER", title: "Royal Flush Jackpot", body: "Flop a royal and take the lot. The jackpot progresses every week until it is claimed — live at every venue on the circuit." },
      { kind: "OFFER", title: "Free Entry Promo", body: "Free entries drawn at the advertised time. Be in the venue to claim it." },
      { kind: "OFFER", title: "Early Bird", body: "Arrive before the game starts and take a 5K chip bonus on your starting stack." },
      { kind: "NEWS", title: "CRP Player — members only", body: "Free membership: leaderboards, merch shop, booking system and the full series schedule." },
    ],
    posters: [
      { src: "/assets/clubs/crp/promo_royal.png", label: "Royal Flush" },
      { src: "/assets/clubs/crp/promo_freeentry.png", label: "Free Entry" },
      { src: "/assets/clubs/crp/promo_earlybird.png", label: "Early Bird" },
    ],
    gallery: [
      "/assets/clubs/crp/photo_table.jpg",
      "/assets/clubs/crp/photo_table2.jpg",
      "/assets/clubs/crp/photo_cash.jpg",
      "/assets/clubs/crp/photo_room.jpg",
    ],
    schedule: [],
    contact: { email: "info@checkraisepoker.com.au", phone: "0413 712 452", region: "South East Queensland" },
  },
  {
    slug: "asp",
    name: "Allstars Poker",
    short: "Allstars",
    tile: "/assets/club_asp.png",
    tileFit: "cover",
    tileBg: "#000000",
    tileLogo: "/assets/clubs/asp/logo_tile-v1.png",
    theme: {
      ground: "#070B1E",
      surface: "#0F1838",
      line: "rgba(255,255,255,0.14)",
      ink: "#FFFFFF",
      inkSoft: "rgba(255,255,255,0.66)",
      accent: "#D7192A",        // the logo's red star
      accentDeep: "#1C3F94",    // the logo's blue lettering
      onAccent: "#FFFFFF",
      display: "'Questrial', 'Unbounded', sans-serif",
      body: "'Questrial', 'IBM Plex Sans', sans-serif",
      displayTracking: "0.04em",
      radius: "10px",
      pill: "9999px",
    },
    logo: "/assets/clubs/asp/logo_tile-v1.png",
    logoDark: "/assets/clubs/asp/logo_tile-v1.png",
    logoClass: "h-16 md:h-24",
    felt: "table_felt_black",
    lobby: "/assets/clubs/asp/bg_room-v3.jpg",
    tvs: [[[158, 851], [410, 918], [410, 1069], [158, 993]], [[2050, 932], [2474, 805], [2474, 1271], [2050, 1240]], [[3454, 1066], [3757, 1061], [3757, 1231], [3454, 1237]]],
    hero: "/assets/clubs/asp/photo_winner.jpg",
    eyebrow: "Players Room · club lounge",
    headline: "Poker for the players",
    blurb:
      "Allstars Poker run nightly tournaments across South East and North Queensland — free to play, semi pro and " +
      "pro games, with coaching for beginners and a Monthly Rewards Game that gives back. This is their room " +
      "inside Players Room.",
    ticker: ["NEW EVENTS", "SATELLITES", "ALLSTARS QUARTERLY REWARDS"],
    cta: { label: "Tonight's games", href: "#games" },
    venues: [  // scraped from allstarspoker.com.au venue pages, Oct 2026
      v("MON", "Beaudesert", "7pm", "Beaudesert Hotel · 30k stack", "$25", "", "", "6.30pm", "8.30pm"),
      v("MON", "Gold Coast", "6.30pm", "Hotel Pacific · 30k stack", "$25", "", "", "6pm", "8pm"),
      v("MON", "Ipswich", "7pm", "Night · 25k stack", "$25", "", "", "6.30pm", "8.30pm"),
      v("MON", "Toowoomba", "7pm", "Club Toowoomba · 40k stack", "$15", "", "", "6.30pm", "8.30pm"),
      v("TUE", "Gatton", "6.30pm", "Night · 40k stack", "$20", "", "", "6pm", "8pm"),
      v("TUE", "Gold Coast", "7pm", "30k stack", "$25", "", "", "6.30pm", "8.30pm"),
      v("TUE", "Ipswich", "7pm", "Walloon Hotel · Night · 25k stack", "$15", "", "", "6.30pm", "8.30pm"),
      v("TUE", "Toowoomba", "7pm", "10k stack", "FREE", "", "", "6.30pm", "8.30pm"),
      v("WED", "Ipswich", "11am", "United Sports Club · Day · 30k stack", "$20", "", "", "10.30am", "12.30pm"),
      v("WED", "Ipswich", "6.30pm", "Night · 40k stack", "$35", "", "", "6pm", "8pm"),
      v("WED", "Laidley", "7pm", "Exchange Hotel · Night · 30k stack", "$15", "", "", "6.30pm", "8.30pm"),
      v("WED", "Toowoomba", "7pm", "Fiveways Hotel · Night · 40k stack", "$25", "", "", "6.30pm", "8.30pm"),
      v("THU", "Ipswich", "7pm", "United Sports Club · Night · 30k stack", "$20", "", "", "6.30pm", "8.30pm"),
      v("THU", "Pittsworth", "7pm", "Pittsworth Hotel Motel · 30k stack", "$35", "", "", "6.30pm", "8.30pm"),
      v("FRI", "Ipswich", "11am", "United Sports Club · Day · 20k stack", "$15", "", "", "10.30am", "12.30pm"),
      v("FRI", "Ipswich", "7pm", "United Sports Club · Night · 40k stack", "$25", "", "", "6.30pm", "8.30pm"),
      v("SAT", "Gold Coast", "4pm", "30k stack", "$35", "", "", "3.30pm", "5.30pm"),
      v("SAT", "Ipswich", "12pm", "United Sports Club · Day · 20k stack", "$5", "", "", "11.30am", "1.30pm"),
      v("SAT", "Ipswich", "6.30pm", "United Sports Club · Night · 50k stack", "$35", "", "", "6pm", "8pm"),
      v("SAT", "Toowoomba", "2.30pm", "Fiveways Hotel · 40k stack", "$25", "", "", "2pm", "4pm"),
      v("SUN", "Ipswich", "1.30pm", "United Sports Club · 30k stack", "$20", "", "", "1pm", "3pm"),
      v("SUN", "Ipswich", "6pm", "United Sports Club · Night", "$15", "", "", "5.30pm", "7.30pm"),
    ],
    notices: [
      { kind: "SERIES", title: "Allstars Poker Series", body: "The club's flagship series — satellites and qualification run through the circuit." },
      { kind: "OFFER", title: "Monthly Rewards Game", body: "Every month we give back to the players with the Monthly Rewards Game." },
      { kind: "NEWS", title: "Dealer Dealt Events", body: "Professionally dealt feature events — the last one paid a $10,720 prizepool." },
    ],
    posters: [
      { src: "/assets/clubs/asp/promo_bingo.jpg", label: "Bingo" },
      { src: "/assets/clubs/asp/promo_trivia.jpg", label: "Trivia" },
      { src: "", label: "Poster slot" },
    ],
    gallery: [],
    schedule: [],
    contact: { email: "", phone: "", region: "South East & North Queensland" },
  },
  {
    slug: "qbp",
    name: "Queen B's Poker",
    short: "Queen B's",
    tile: "/assets/club_qbp.png",
    tileFit: "cover",
    tileBg: "#1D2B78",
    tileLogo: "/assets/clubs/qbp/logo_tile-v1.png",
    theme: {
      ground: "#1D2B78",
      surface: "#16215E",
      line: "rgba(197,176,92,0.40)",
      ink: "#FFFFFF",
      inkSoft: "#C9CFE8",
      accent: "#C5B05C",
      accentDeep: "#2A3C9E",
      onAccent: "#1D2B78",
      display: "'Roboto', 'Unbounded', sans-serif",
      body: "'Roboto', 'IBM Plex Sans', sans-serif",
      displayTracking: "0.02em",
      radius: "6px",
      pill: "9999px",
    },
    logo: "/assets/clubs/qbp/logo_gold_full.png",
    logoDark: "/assets/clubs/qbp/logo_gold_full.png",
    felt: "table_felt_qbp-v2",   // bee emblem at both ends + web address are printed on the felt itself
    feltLogo: false,
    lobby: "/assets/clubs/qbp/bg_room-v10.jpg",
    tvs: [[[494, 962], [779, 1090], [779, 1275], [494, 1198]], [[3037, 1085], [3320, 963], [3320, 1199], [3037, 1271]]],
    bgPos: "center 30%",
    hero: "/assets/clubs/qbp/bg_hero.png",
    eyebrow: "Players Room · club lounge",
    headline: "Poker done better",
    blurb:
      "Queen B's Poker is South East Queensland's purpose-built tournament room at 100 York St, Beenleigh — twelve " +
      "regular weekly tournaments, major series and promotions funded entirely out of admin fees. This is their " +
      "room inside Players Room.",
    ticker: ["POKER DONE BETTER", "699 TOURNAMENTS RUN · $4,772,456 PAID IN PRIZE POOLS"],
    cta: { label: "Tonight's games", href: "#games" },
    venues: [  // one room (100 York St, Beenleigh): event name, start, buy-in — from queenbs.live/schedule, Oct 2026
      v("TUE", "Cheap Tuesday", "6pm", "", "$135"),
      v("TUE", "Beenleigh Splitteigh Satellite", "8:30pm", "", "$65"),
      v("WED", "Wednesday Honey Pot", "6pm", "", "$160"),
      v("WED", "PLO5 Satellite", "9pm", "", "$80"),
      v("THU", "Thursday Turbo Deepstack", "6pm", "", "$135"),
      v("THU", "H.O.P. Satellite", "9pm", "", "$65"),
      v("FRI", "TGI Friday", "6pm", "", "$355"),
      v("FRI", "Friday Bounty Collector", "6:30pm", "", "$50"),
      v("FRI", "Friday NLH Up Late Satellite", "9pm", "", "$80"),
      v("SAT", "Super Size Freezeout", "2pm", "", "$455"),
      v("SAT", "Bumper Progressive Bounty", "4pm", "", "$240"),
      v("SAT", "Birthday Giddy Up", "6:30pm", "", "$60"),
      v("SAT", "Saturday NLH Up Late Satellite", "9pm", "", "$65"),
      v("SUN", "Sunday Grind", "12pm", "", "$300"),
      v("SUN", "Sunday Deepstacks", "1pm", "", "$65"),
    ],
    notices: [
      { kind: "SERIES", title: "Wacky Week", body: "Six days, $190,000+ guaranteed. Poker like never before." },
      { kind: "OFFER", title: "Queen's Quest", body: "Win your way to the WSOP in Las Vegas — two seats, points accumulated across the leaderboard." },
      { kind: "OFFER", title: "Fortune Reversal", body: "Bad beat jackpot. Starts at $1,000 and grows $200 every week until it is claimed." },
      { kind: "OFFER", title: "Reinvest and Save", body: "Cash in any tournament and reinvest into a dealer-dealt event for 30% off the admin fee." },
    ],
    posters: [
      { src: "/assets/clubs/qbp/promo_queens_quest.png", label: "Queen's Quest" },
      { src: "/assets/clubs/qbp/promo_fortune_reversal.png", label: "Fortune Reversal" },
      { src: "/assets/clubs/qbp/promo_reinvest.png", label: "Reinvest & Save" },
    ],
    gallery: [
      "/assets/clubs/qbp/photo_0022.png",
      "/assets/clubs/qbp/photo_0142.png",
      "/assets/clubs/qbp/photo_0293.png",
      "/assets/clubs/qbp/photo_0128.png",
    ],
    schedule: [],
    contact: { email: "play@queenbs.poker", phone: "", region: "100 York St, Beenleigh" },
  },
  {
    slug: "mga",
    name: "Mixed Games Academy",
    short: "MGA",
    tile: "/assets/clubs/mga/logo_full.png",
    tileFit: "cover",
    tileBg: "#111214",
    tileLogo: "/assets/clubs/mga/logo_wide-v1.png",   // spade left, name right: reads at tile size
    tier: "TIER2",
    theme: {
      ground: "#111214",
      surface: "#17191D",
      line: "rgba(200,154,50,0.38)",
      ink: "#F2EEE6",
      inkSoft: "#C7CBD0",
      accent: "#C89A32",
      accentDeep: "#E4CC75",
      onAccent: "#111214",
      display: "'Montserrat', 'Unbounded', sans-serif",
      body: "'Montserrat', 'IBM Plex Sans', sans-serif",
      displayTracking: "0.08em",
      radius: "4px",
      pill: "9999px",
    },
    logo: "/assets/clubs/mga/logo_full.png",
    logoDark: "/assets/clubs/mga/logo_full.png",
    felt: "table_felt_black",
    feltLogoWidth: "8%",    // tall spade logo: one upright print at each end, inside the betting line
    feltLogoEnds: true,
    lobby: "/assets/clubs/mga/bg_room-v1.jpg",       // table room: Art Deco club, two logo TVs on the back wall
    lounge: "/assets/clubs/mga/bg_lounge-v1.jpg",    // club lobby: black-marble salon
    tvs: [[[434, 881], [1024, 881], [1024, 1228], [434, 1228]], [[2922, 878], [3531, 878], [3531, 1231], [2922, 1231]]],
    bgPos: "center 30%",
    eyebrow: "Players Room · club lounge",
    headline: "Learn the games. Find your game.",
    blurb:
      "Mixed Games Academy runs structured mixed-game poker education and specialist live events at PlayLive " +
      "Melbourne — T.O.R.S.E., THORSE Cup, 8- and 9-Game Mixes, Drawmaha and more. This is their room inside Players Room.",
    ticker: ["LEARN THE GAMES · FIND YOUR GAME", "THORSE CUP · NOVEMBER 2026 · PLAYLIVE MELBOURNE", "SUMMER MIX OF 26 · DECEMBER"],
    cta: { label: "Tonight's games", href: "#games" },
    venues: [  // mixedgamesacademy.au/events, Oct 2026 — PlayLive Melbourne, times AEDT
      v("THU", "T.O.R.S.E. · 22 Oct", "6:15pm", "", "$275"),
      v("THU", "THORSE Cup Qualifier · 5 Nov", "6:15pm", "", "$350"),
      v("FRI", "THORSE Cup First Furlong · 6 Nov", "6:15pm", "", "$750"),
      v("SAT", "THORSE Cup Second Furlong · 7 Nov", "11:30am", "", "$750"),
      v("SAT", "THORSE Cup Home Straight · 7 Nov", "6:30pm", "", "$750"),
      v("THU", "8-Game Mix · 12 Nov", "6:15pm", "", "$275"),
      v("THU", "9 Game Mix · 3 Dec", "6:15pm", "", "$500"),
      v("FRI", "Drawmaha · 4 Dec", "6:15pm", "", "$500"),
      v("SAT", "T.H.O.R.S.E. · 5 Dec", "2pm", "", "$500"),
      v("SAT", "Penta-Mix · 5 Dec", "7pm", "", "$500"),
      v("SUN", "MGA Fun Mix · 6 Dec", "2pm", "", "$500"),
    ],
    notices: [
      { kind: "SERIES", title: "THORSE Cup", body: "Qualifier 5 Nov, two Furlongs 6–7 Nov, Home Straight restart 7 Nov — full six-game rotation at PlayLive Melbourne." },
      { kind: "SERIES", title: "Summer Mix of 26", body: "MGA December: 9 Game Mix, Drawmaha, T.H.O.R.S.E., Penta-Mix and the MGA Fun Mix, 3–6 December." },
      { kind: "OFFER", title: "MGA Foundations", body: "From unfamiliar to table ready — structured lessons for every game in the mix." },
    ],
    ad: { src: "/assets/clubs/mga/ad_playlive-v1.png", label: "PlayLive Melbourne", href: "https://playlive.melbourne/", bg: "#000" },  // their venue partner
    posters: [{ src: "/assets/clubs/mga/poster_lesson_to_felt.jpg", label: "From Lesson to Felt" }],
    gallery: ["/assets/clubs/mga/poster_lesson_to_felt.jpg"],
    schedule: [],
    contact: { email: "", phone: "", region: "PlayLive Melbourne" },
  },
];

export const CLUB_SLUGS = CLUBS.map((c) => c.slug);
export const getClub = (slug) => CLUBS.find((c) => c.slug === String(slug || "").toLowerCase());
